/**
 * Firebase auth route guard
 *
 * Wraps post–phone-verification routes and redirects unauthenticated users to
 * phone verification while auth state is resolving.
 */

import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { auth } from '../../firebaseConfig';
import { OnboardingFlowLoadingScreen } from './components/layout/OnboardingFlowLoadingScreen';

const PHONE_VERIFICATION_PATH = '/webAppOnboarding/phone-verification';

/**
 * Renders child routes only when a Firebase user is signed in; otherwise shows loading or redirects.
 *
 * @return {Object} React outlet or loading screen.
 */
export function OnboardingAuthGuard() {
  const navigate = useNavigate();
  const [hasFirebaseUser, setHasFirebaseUser] = useState<boolean | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate(PHONE_VERIFICATION_PATH, { replace: true });
        setHasFirebaseUser(false);
        return;
      }
      setHasFirebaseUser(true);
    });

    return unsubscribe;
  }, [navigate]);

  if (hasFirebaseUser !== true) {
    return <OnboardingFlowLoadingScreen />;
  }

  return <Outlet />;
}
